if (!customElements.get('editorial-product-grid')) {
  class EditorialProductGrid extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-editorial-collection-section]');
      this.facetMain = this.closest('#facet-main');

      if (!this.section || !this.facetMain) return;

      this.abortController = new AbortController();
      this.buttons = Array.from(this.facetMain.querySelectorAll('[data-editorial-layout-toggle]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onToggle.bind(this), {
          signal: this.abortController.signal
        });
      });

      const initialLayout = this.section.dataset.editorialLayout || this.section.dataset.editorialInitialLayout || 'editorial';
      this.setLayout(initialLayout);
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
    }

    onToggle(event) {
      event.preventDefault();
      this.setLayout(event.currentTarget.dataset.editorialLayoutToggle || 'editorial');
    }

    setLayout(layout) {
      const normalizedLayout = layout === 'grid' ? 'grid' : 'editorial';
      this.section.dataset.editorialLayout = normalizedLayout;

      this.buttons.forEach((button) => {
        const isActive = button.dataset.editorialLayoutToggle === normalizedLayout;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        /*
        * Conservamos también la clase active
        * del código original de los botones.
        */
        button.classList.toggle('active', isActive);

        /*
        * aria-current solamente debe estar presente
        * en el botón de la vista seleccionada.
        */
        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      this.refreshVisibleCarousels();

      this.dispatchEvent(new CustomEvent('editorial:layout-changed', {
        bubbles: true,
        detail: { layout: normalizedLayout }
      }));
    }

    refreshVisibleCarousels() {
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);

      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = requestAnimationFrame(() => {
          const carousels = Array.from(this.section.querySelectorAll('flickity-carousel'));
          const currentLayout = this.section.dataset.editorialLayout;

          carousels.forEach(async (carousel) => {
            if (!carousel.flickityInstance) return;

            try {
              const flickity = await carousel.flickityInstance;
              if (
                !flickity ||
                !carousel.isConnected ||
                carousel.offsetParent === null ||
                this.section.dataset.editorialLayout !== currentLayout
              ) return;

              flickity.resize();
              flickity.reposition();
            } catch (error) {
              // A carousel may be disconnected while filters or the theme editor reload the section.
            }
          });

          this.layoutFrame = null;
        });
      });
    }
  }

  customElements.define('editorial-product-grid', EditorialProductGrid);
}
